import { useMemo } from "react"
import { useLocation } from "react-router-dom"

import { pageHelpTab } from "@app/@signals"
import { repricingPass } from "@signals/filters/web"
import { userSettingsTab } from "Pages/User/Settings/@signals/tabs"
import { screenHelpFor } from "@utils/askIris/screen"

// Manage Settings already publishes its open tab; Setup publishes `pageHelpTab` (its default tab has no `?tab=`)
const TAB_SOURCE = { 'user-settings': () => userSettingsTab.value }

/**
 * Ask Iris in help mode (CU-869fmufdb): `{ id, name, hint }` of the screen on display, or null when it has no help
 * page (no header icon). Read at render time from the path, the open tab and the repricing pass (DOR/LOR).
 */
export default function useScreenHelp() {
	const { pathname } = useLocation()
	const base = screenHelpFor(pathname)
	const tab = base ? (TAB_SOURCE[base.id] || (() => pageHelpTab.value))() : null
	const pass = base ? repricingPass.value : null
	return useMemo(() => (base ? screenHelpFor(pathname, { tab, pass: !!pass }) : null), [pathname, tab, !!pass])
}
